import "./src/theme/default/_standard.scss";
import "./src/theme/default/_baseline.scss";
import "./src/fonts/fonts.scss";

// refresh when service worker is updated
// https://www.gatsbyjs.com/docs/add-offline-support-with-a-service-worker/#displaying-a-message-when-a-service-worker-updates
export const onServiceWorkerUpdateReady = () => window.location.reload();